module.exports = __webpack_public_path__ + "static/media/bursts_08.2b8312f7.svg";